import React , { useState } from 'react';
import { IoCalendarSharp } from 'react-icons/io5'; 
import { FiChevronDown, FiBell } from 'react-icons/fi'; 
import DatePicker from '../../../components/DatePicker';
import { getLocalTodayString } from '../../../components/CreationDate';

const RotaOverview = () => {

    const [selectedDate, setSelectedDate] = React.useState(getLocalTodayString());

    const notifications = [
        { id: 1, title: 'Temperature alert', message: 'Freezer A is above the safe threshold.', time: '5 min ago', unread: true },
        { id: 2, title: 'Maintenance scheduled', message: 'Fridge 2 service is due tomorrow.', time: '1 hour ago', unread: false },
        { id: 3, title: 'New compliance task', message: 'Review the latest audit checklist.', time: 'Yesterday', unread: true },
    ];
    
    const hasUnread = notifications.some(n => n.unread);

    return (
        <section className="flex items-center justify-between">
            <div>
                <h2 className="text-2xl font-bold">Good Morning, Arslan</h2>  
                <p className="text-gray-600">Everything looks good. Your equipment is operating within safe temperature ranges.</p>
            </div>

            <div className="flex items-center gap-4"> 
                <DatePicker selectedDate={selectedDate} setSelectedDate={setSelectedDate} />

                {/* 1. Added a relative container with 'group' to trigger hover events */}
                <div className="relative group z-50">
                    
                    {/* Bell Button */}
                    <button className="relative flex items-center justify-center w-10 h-10 text-gray-600 hover:text-gray-900 focus:outline-none transition-colors" aria-label="Notifications">
                        <FiBell className="w-6 h-6" />
                        
                        {/* 2. Fixed unread dot layout position using standard Tailwind utility tokens */}
                        {hasUnread && (
                            <span className="absolute top-1.5 right-1.5 flex h-2.5 w-2.5">
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500"></span>
                            </span>
                        )}
                    </button>

                    {/* 3. Absolute Dropdown List - Hidden by default, displayed via group-hover */}
                    <div className="absolute right-0 top-full mt-1 w-80 bg-white border border-gray-200 rounded-xl shadow-xl hidden group-hover:block transition-all duration-200">
                        <div className="p-3 border-b border-gray-100 flex items-center justify-between">
                            <h3 className="font-semibold text-gray-800 text-sm">Notifications</h3>
                            <span className="text-xs text-blue-500 font-medium">Clear all</span>
                        </div>
                        <div className="max-h-64 overflow-y-auto">
                            {notifications.map((item) => (
                                <div key={item.id} className={`p-3 border-b border-gray-50 last:border-0 hover:bg-gray-50 transition-colors flex gap-2 ${item.unread ? 'bg-blue-50/40' : ''}`}>
                                    {item.unread && (
                                        <div className="mt-1.5 min-w-[6px] h-[6px] bg-blue-500 rounded-full" />
                                    )}
                                    <div className="flex-1">
                                        <div className="flex justify-between items-baseline gap-2">
                                            <h4 className="text-xs font-semibold text-gray-900 truncate">{item.title}</h4>
                                            <span className="text-[10px] text-gray-400 whitespace-nowrap">{item.time}</span>
                                        </div>
                                        <p className="text-xs text-gray-500 mt-0.5 line-clamp-2">{item.message}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </div>
       </section>
    )
}

export default RotaOverview;
